import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';

register('blog-section', [slider]);
